export type ReadOnlyVariant = 'plain' | 'boxed';

// This map MUST stay in sync with Authorization/PermissionMatrix.cs GetAppraisalSections ownership
// (linked-pair correctness invariant).
const SECTION_OWNER_ROLES: Record<string, readonly string[]> = {
  appraisalDetails: ['Collator', 'Delegate'],
  projectInterviews: ['Appraisee', 'Collator', 'Delegate'],
  interviewSummary: ['Appraisee', 'Collator', 'Delegate'],
  selfAssessment: ['Appraisee'],
  performanceSummary: ['Collator', 'Delegate'],
  collatorComments: ['Collator', 'Delegate'],
  skillAreaStrengths: ['Collator', 'Delegate'],
  forwardLookingPlan: ['Collator', 'Delegate'],
  notesToTalentCommittee: ['Collator', 'Delegate'],
  upwardFeedback: [],
  notesActionsForCollator: ['SystemRole'],
  staffingTcNotes: ['SystemRole'],
};

export function readOnlySectionVariant(
  sectionKey: string,
  viewerRole: string | undefined
): ReadOnlyVariant {
  const owners = SECTION_OWNER_ROLES[sectionKey];
  if (!owners || !viewerRole) {
    return 'boxed';
  }
  return owners.includes(viewerRole) ? 'boxed' : 'plain';
}
